export const BASE_URL_SANCTUM = '/sanctum/csrf-cookie/';
export const RECAPTCHA_SITE_KEY = process.env.MIX_RECAPTCHA_SITE_KEY;
export const CRUISES_API = '/api/cruises';
